export default __webpack_public_path__ + "static/media/books-1440w.0d94e353.webp";